export const RISK_PALETTE = {
  low: '#66CDAA',
  elevated: '#F2C94C',
  high: '#e33121',
};

export const RISK_OUTLINE = {
  low: '#3B9E7A',
  elevated: '#B08A1A',
  high: '#C7543D',
};